import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AgricultureLoanPage from '@/pages/AgricultureLoanPage';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import AboutPage from './pages/About';
import ContactPage from './pages/ContactPage';
import { CONTACT_INFO } from '@/utils/constants';
import BusinessLoanPage from './pages/BusinessLoanPage';
import PersonalLoanPage from './pages/PersonalLoanPage';
import EducationLoanPage from './pages/EducationLoanPage';
import ProjectLoan from './pages/ProjectLoan';
import HomeLoanPage from './pages/HomeLoanPage';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/*" element={
            <>
              <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/business-loan" element={<BusinessLoanPage />} />
                <Route path="/personal-loan" element={<PersonalLoanPage />} />
                <Route path="/education-loan" element={<EducationLoanPage />} />
                <Route path="/home-loan" element={<HomeLoanPage />} />
                <Route path="/project-loan" element={<ProjectLoan />} />
                <Route path="/agriculture-loan" element={<AgricultureLoanPage />} />
              </Routes>
              <Footer />

              <a
                href={`https://wa.me/${CONTACT_INFO.whatsapp}`}
                className="whatsapp-float"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-float"
              >
                <svg viewBox="0 0 32 32" width="32" height="32">
                  <path fill="currentColor" d="M16 0C7.164 0 0 7.164 0 16c0 2.828.736 5.484 2.024 7.776L0 32l8.448-2.016A15.912 15.912 0 0 0 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm8.252 22.74c-.344.964-1.716 1.776-2.8 2.008-.748.16-1.72.288-4.992-.976-4.184-1.616-6.884-5.876-7.092-6.144-.204-.268-1.676-2.22-1.676-4.232 0-2.012 1.06-3.004 1.436-3.412.376-.408.824-.512 1.1-.512.276 0 .548.004.788.016.252.012.592-.096.924.704.344.828 1.168 2.84 1.268 3.048.1.208.168.452.032.72-.132.268-.2.436-.396.668-.196.232-.412.52-.588.696-.196.196-.4.408-.172.8.228.392 1.016 1.672 2.18 2.708 1.496 1.328 2.756 1.74 3.148 1.936.392.196.62.164.848-.1.228-.264.976-1.136 1.236-1.528.26-.392.52-.328.876-.196.356.132 2.268 1.068 2.656 1.264.388.196.648.292.744.456.096.164.096.948-.248 1.912z" />
                </svg>
              </a>
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;